import classNames from 'classnames'
import type { FunctionComponent } from 'react'
import React from 'react'

import { ActionButton } from '../../../contentful-components/action-button'
import type { BannerFragment } from '../../../graphql/fragments/BannerFragment.graphql'
import { TEXT } from '../../../lib/utils/text'
import { withTheme } from '../../../lib/utils/withTheme'
import { asColorLabel } from '../../../types/color'
import { CloseIcon } from '../../svgs'
import { Text } from '../../text'
import { Container } from '../grid'
import styles from './header-banner.module.scss'

export const HeaderBanner: FunctionComponent<Props> = ({
    button,
    color,
    copy,
    image,
    theme,
    onClose,
}) => {
    return withTheme(
        theme?.key,
        <div
            data-testid='layout.headerBanner'
            className={classNames(
                styles.banner,
                styles[`background-${asColorLabel(color)}`]
            )}
        >
            <button
                onClick={() => onClose?.()}
                aria-label={TEXT.close}
                className={styles.close}
            >
                <CloseIcon width='15' />
            </button>
            <Container>
                <div className={styles.inner}>
                    <div className={styles['inner-row']}>
                        {image?.source && (
                            <img src={image?.source} className={styles.image} />
                        )}
                        <div className={styles.content}>
                            <Text
                                tag='div'
                                typeStyle={{
                                    _: 'body-2xs',
                                    md: 'body-lg',
                                }}
                            >
                                {copy}
                            </Text>

                            {button && (
                                <div className={styles.button}>
                                    <ActionButton {...button} size='small' />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default HeaderBanner

interface Props extends Omit<BannerFragment, 'type' | 'sys'> {
    onClose?: () => void
}
